export const FILE_ICONS = {
   javascript: 'fa-brands fa-js',
   css: 'fa-brands fa-css3-alt',
   html: 'fa-brands fa-html5',
   php: 'fa-brands fa-php',
   // sql: 'sql',
   // json: 'json',
   python: 'fa-brands fa-python',
   java: 'fa-brands fa-java',
   // csharp: 'cs',
   // c: 'c',
   // cpp: 'cpp',
   // ruby: 'rb',
   shell: 'fas fa-terminal',
   go: 'fa-brands fa-golang',
   swift: 'fa-brands fa-swift',
   // perl: 'pl',
   // yaml: 'yaml',
   markdown: 'fa-brands fa-markdown',
   plaintext: 'fa-solid fa-file-lines',
 }